import { render, staticRenderFns } from "./BatchesByCompetenceReport.vue?vue&type=template&id=76dcb4dd"
import script from "./BatchesByCompetenceReport.vue?vue&type=script&lang=js"
export * from "./BatchesByCompetenceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports